import React from 'react';
import { NavLink } from 'react-router-dom';
import { ACTION } from 'constants/index';

import EditApplicationButton from 'Components/EditApplicationButton';

export default ({handleEditClick, applicationStatus, user, applicationId, loadInProgress, availableActions}) => {
  const link = `/${user.getManufacturerCode()}/oil/formula/${applicationId}/edit`;

  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div
        className='go-back-to-list-header-button'
        onClick={() => {
          user.goToList();
        }}
      >
        Back
      </div>
      <header>Oil Formulation Details</header>
      {!loadInProgress && (
        <React.Fragment>
          {availableActions.find(act => act.name === ACTION.EDIT) && (
            <NavLink to={link}>
              <EditApplicationButton />
            </NavLink>
          )}
          <div className={`detailsScene__status-label ${applicationStatus.toLowerCase()}`}>
            {applicationStatus.toLowerCase()}
          </div>
        </React.Fragment>
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Details/Header.jsx